import { Box, Button, Card, styled, useTheme, Tabs, Tab, Typography, useMediaQuery } from "@mui/material";
import AppPagination from "components/AppPagination";
import { GetApp } from "@mui/icons-material";
import FlexBetween from "components/flexbox/FlexBetween";
import FlexBox from "components/flexbox/FlexBox";
import SearchInput from "components/input-fields/SearchInput";
import { useEffect, useState } from "react";
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";
import { usePageTitle } from "contexts/PageTitleContext";
import { useToast } from "OtherReusableFunctionality/ToastContext";
import ReturnCancelRequestTable from "./ReturnCancelRequestTable";
import AdvancedExportModal from "pages/Products/AdvancedExportModal";
import { alpha } from "@mui/material/styles";
import ConfirmationDialog from "components/ConfirmationDialog";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  minHeight: 48,
  width: "100%",
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    gap: 4,
    padding: 4,
  },
  "& .MuiTabs-scroller": {
    [theme.breakpoints.up("md")]: {
      "& .MuiTabs-flexContainer": {
        justifyContent: "space-between",
      },
    },
  },
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 2px 8px rgba(0,0,0,0.3)"
      : "0 2px 8px rgba(0,0,0,0.1)",
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.875rem",
  minHeight: 40,
  borderRadius: theme.shape.borderRadius,
  margin: 0,
  padding: "8px 16px",
  color: theme.palette.text.secondary,
  transition: "all 0.2s ease-in-out",
  position: "relative",
  [theme.breakpoints.up("md")]: {
    flex: 1,
    minWidth: 0,
  },
  [theme.breakpoints.down("md")]: {
    minWidth: 120,
    padding: "8px 12px",
    fontSize: "0.8rem",
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const getStatusColor = (theme, status) => {
  const colors = {
    cancelled: theme.palette.error.main,
    returned: theme.palette.error.dark,
  };
  return colors[status] || theme.palette.grey[500];
};

const TabContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  position: "sticky",
  top: 0,
  zIndex: 10,
  backgroundColor: theme.palette.background.default,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

const TABS = [
  { value: "Cancelled", label: "Cancel Request", category: "cancelled" },
  { value: "Returned", label: "Return Request", category: "returned" },
];

const ReturnCancelRequest = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { setPageTitle } = usePageTitle();
  const toast = useToast();

  const [products, setProducts] = useState([]);
  const [statusFilter, setStatusFilter] = useState("Cancelled");
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [advancedExportModal, setAdvancedExportModal] = useState(false);
  const [counts, setCounts] = useState({ Cancelled: 0, Returned: 0 });
  const [updatingOrderId, setUpdatingOrderId] = useState(null);
  const [updatingReturnOrderId, setUpdatingReturnOrderId] = useState(null);
  const [checkingPaymentOrderId, setCheckingPaymentOrderId] = useState(null);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
    confirmButtonText: "Confirm",
    confirmButtonColor: "primary",
  });

  useEffect(() => {
    setPageTitle("Return & Cancel Request");
  }, [setPageTitle]);

  // const fetchProducts = async (status = statusFilter) => {
  //   setIsLoading(true);
  //   try {
  //     const userId = localStorage.getItem("user_id");
  //     if (status === "Cancelled") {
  //       const response = await apiService.get(
  //         `${API_ENDPOINTS.Get_cancel_request}?user_id=${userId}&page=${currentPage}&page_size=${pageSize}`
  //       );
  //       const raw = Array.isArray(response?.data)
  //         ? response.data
  //         : Array.isArray(response?.results)
  //           ? response.results
  //           : [];
  //       const list = raw.map((item) => {
  //         const requestAction = item.cancel_request_action ?? item.action ?? item.advance_payment.order.request_status ?? item.status;
  //         if (item?.order && typeof item.order === "object") {
  //           return {
  //             ...item.order,
  //             id: item.order.id || item.id,
  //             cancel_request_action: requestAction,
  //           };
  //         }
  //         return { ...item, id: item.id || item.order_id, cancel_request_action: requestAction };
  //       });
  //       setProducts(list);
  //       // Try to read pagination info from response
  //       const pagination = response?.pagination || response?.data?.pagination || response?.results?.pagination || null;
  //       setTotalItems(pagination?.total_items ?? list.length);
  //       setTotalPages(pagination?.total_pages ?? 1);
  //       setCounts((prev) => ({ ...prev, Cancelled: pagination?.total_items ?? list.length }));
  //     } else if (status === "Returned") {
  //       try {
  //         const response = await apiService.get(`${API_ENDPOINTS.Get_return_request}?user_id=${userId}&page=${currentPage}&page_size=${pageSize}`);
  //         const raw = Array.isArray(response?.data)
  //           ? response.data
  //           : Array.isArray(response?.results)
  //             ? response.results
  //             : Array.isArray(response)
  //               ? response
  //               : [];
  //         const list = raw.map((item) => {
  //           const requestAction = item.return_request_action ?? item.action ?? item.request_status ?? item.status;
  //           if (item?.order && typeof item.order === "object") {
  //             return {
  //               ...item.order,
  //               id: item.order.id || item.id,
  //               return_request_action: requestAction,
  //             };
  //           }
  //           return { ...item, id: item.id || item.order_id, return_request_action: requestAction };
  //         });
  //         setProducts(list);
  //         const pagination = response?.pagination || response?.data?.pagination || response?.results?.pagination || null;
  //         setTotalItems(pagination?.total_items ?? list.length);
  //         setTotalPages(pagination?.total_pages ?? 1);
  //         setCounts((prev) => ({ ...prev, Returned: pagination?.total_items ?? list.length }));
  //       } catch (err) {
  //         console.error('Error fetching return requests:', err);
  //         setProducts([]);
  //       }
  //     } else {
  //       const statusParam = `&status=${encodeURIComponent(status)}`;
  //       const url = `${API_ENDPOINTS.GET_products}?user_id=${userId}${statusParam}&type=normal`;
  //       const response = await apiService.get(url);
  //       const list = Array.isArray(response?.data)
  //         ? response.data
  //         : Array.isArray(response?.results)
  //           ? response.results
  //           : Array.isArray(response)
  //             ? response
  //             : [];
  //       setProducts(list);
  //       setCounts((prev) => ({ ...prev, [status]: list.length }));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching return/cancel requests:", error);
  //     setProducts([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchProducts = async (status = statusFilter) => {
  setIsLoading(true);
  const userId = localStorage.getItem("user_id");

  try {
    // 🚀 Fetch both cancel & return at same time
    const [cancelRes, returnRes] = await Promise.all([
      apiService.get(
        `${API_ENDPOINTS.Get_cancel_request}?user_id=${userId}&page=${currentPage}&page_size=${pageSize}`
      ),
      apiService.get(
        `${API_ENDPOINTS.Get_return_request}?user_id=${userId}&page=${currentPage}&page_size=${pageSize}`
      )
    ]);

    // 🔹 Extract Cancel Count
    const cancelPagination =
      cancelRes?.pagination ||
      cancelRes?.data?.pagination ||
      null;

    const cancelCount =
      cancelPagination?.total_items ??
      cancelRes?.data?.length ??
      0;

    // 🔹 Extract Return Count
    const returnPagination =
      returnRes?.pagination ||
      returnRes?.data?.pagination ||
      null;

    const returnCount =
      returnPagination?.total_items ??
      returnRes?.data?.length ??
      0;

    // 🔥 Update BOTH counts
    setCounts({
      Cancelled: cancelCount,
      Returned: returnCount
    });

    // 🔥 Show only selected tab data
    const activeResponse =
      status === "Cancelled" ? cancelRes : returnRes;

    const raw = Array.isArray(activeResponse?.data)
      ? activeResponse.data
      : Array.isArray(activeResponse?.results)
      ? activeResponse.results
      : [];

    const list = raw.map((item) => ({
      ...(item.order || item),
      id: item?.order?.id || item.id
    }));

    const pagination =
      activeResponse?.pagination ||
      activeResponse?.data?.pagination ||
      null;

    setProducts(list);
    setTotalItems(pagination?.total_items ?? list.length);
    setTotalPages(pagination?.total_pages ?? 1);

  } catch (error) {
    console.error("Error fetching data:", error);
    setProducts([]);
  } finally {
    setIsLoading(false);
  }
};
  useEffect(() => {
    // Fetch whenever page, page size or status changes
    setCurrentPage((p) => p || 1);
    fetchProducts(statusFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, statusFilter]);

  const handlePageChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleStatusChange = (event, newValue) => {
    setCurrentPage(1);
    setStatusFilter(newValue);
  };

  const handleRefresh = async () => {
    await fetchProducts(statusFilter);
  };

  useEffect(() => {
    setSelectedProducts([]);
    setIsAllSelected(false);
  }, [statusFilter]);

  const handleProductSelect = (productId, isSelected) => {
    setSelectedProducts((prev) => {
      if (isSelected) {
        const newSelected = [...prev, productId];
        setIsAllSelected(newSelected.length === products.length);
        return newSelected;
      }
      const newSelected = prev.filter((id) => id !== productId);
      setIsAllSelected(false);
      return newSelected;
    });
  };

  const handleSelectAll = (selectAll) => {
    if (selectAll) {
      setSelectedProducts(products.map((p) => p.id));
      setIsAllSelected(true);
    } else {
      setSelectedProducts([]);
      setIsAllSelected(false);
    }
  };

  const handleExport = async (format) => {
    const selectedData = products.filter((p) => selectedProducts.includes(p.id));
    if (selectedData.length === 0) {
      alert("Please select orders to export");
      return;
    }
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
    const filename = `return_cancel_export_${timestamp}`;
    if (format === "excel") {
      try {
        const XLSX = await import("xlsx");
        const excelData = selectedData.map((p) => ({
          "Order ID": p.order_id || "",
          "User Name": p.user?.username || p.user_name || "",
          "User Email": p.user?.email || p.user_email || "",
          Status: p.status?.name || p.order_status_display || "",
          "Payment Status": p.payment_status?.name || p.payment_status_display || "",
          "Total Amount": p.total_amount || "",
        }));
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      } catch (e) {
        console.error(e);
        alert("Export failed.");
      }
    } else if (format === "csv") {
      const headers = ["Order ID", "User Name", "User Email", "Status", "Payment Status", "Total Amount"];
      const rows = selectedData.map((p) =>
        [
          `"${p.order_id || ""}"`,
          `"${p.user?.username || p.user_name || ""}"`,
          `"${p.user?.email || p.user_email || ""}"`,
          `"${p.status?.name || p.order_status_display || ""}"`,
          `"${p.payment_status?.name || p.payment_status_display || ""}"`,
          `"${p.total_amount || ""}"`,
        ].join(",")
      );
      const csv = [headers.join(","), ...rows].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
    }
  };

  const handleCancelRequestAction = async (orderId, action) => {
    if (!orderId) return;
    setUpdatingOrderId(orderId);
    try {
      const response = await apiService.post(API_ENDPOINTS.Update_cancel_request, {
        order_id: orderId,
        action: action === "approve" ? "approve" : "reject",
      });
      if (response?.success) {
        const actionValue = action === "approve" ? "approved" : "rejected";
        setProducts((prev) =>
          prev.map((p) =>
            (p.order_id ?? p.id) === orderId
              ? { ...p, cancel_request_action: actionValue }
              : p
          )
        );
        await fetchProducts("Cancelled");
      } else {
        alert(response?.message || "Action failed.");
      }
    } catch (error) {
      console.error("Update cancel request error:", error);
      alert(error?.message || "Action failed.");
    } finally {
      setUpdatingOrderId(null);
    }
  };

  const handleReturnRequestAction = async (orderId, action) => {
    if (!orderId) return;
    setUpdatingReturnOrderId(orderId);
    try {
      const response = await apiService.post(API_ENDPOINTS.Update_return_request, {
        order_id: orderId,
        action: action === "approve" ? "approve" : "reject",
      });
      if (response?.success) {
        const actionValue = action === "approve" ? "approved" : "rejected";
        setProducts((prev) =>
          prev.map((p) =>
            (p.order_id ?? p.id) === orderId
              ? { ...p, return_request_action: actionValue }
              : p
          )
        );
        await fetchProducts("Returned");
      } else {
        alert(response?.message || "Action failed.");
      }
    } catch (error) {
      console.error("Update return request error:", error);
      alert(error?.message || "Action failed.");
    } finally {
      setUpdatingReturnOrderId(null);
    }
  };

  const showConfirmation = (order, action, type) => {
    const isApprove = action === "approve";
    const isCancel = type === "cancel";
    const orderId = order?.order_id ?? order?.id ?? "this order";
    
    setConfirmationDialog({
      open: true,
      title: isApprove 
        ? `Accept ${isCancel ? "Cancel" : "Return"} Request`
        : `Reject ${isCancel ? "Cancel" : "Return"} Request`,
      message: isApprove
        ? `Are you sure you want to accept the ${isCancel ? "cancel" : "return"} request for order ${orderId}?`
        : `Are you sure you want to reject the ${isCancel ? "cancel" : "return"} request for order ${orderId}?`,
      confirmButtonText: isApprove ? "Accept" : "Reject",
      confirmButtonColor: isApprove ? "success" : "error",
      onConfirm: async () => {
        setConfirmationDialog((prev) => ({ ...prev, open: false }));
        if (isCancel) {
          await handleCancelRequestAction(orderId, action);
        } else {
          await handleReturnRequestAction(orderId, action);
        }
      },
    });
  };

  const handleApproveCancelRequest = (order) => {
    showConfirmation(order, "approve", "cancel");
  };

  const handleRejectCancelRequest = (order) => {
    showConfirmation(order, "reject", "cancel");
  };

  const handleApproveReturnRequest = (order) => {
    showConfirmation(order, "approve", "return");
  };

  const handleRejectReturnRequest = (order) => {
    showConfirmation(order, "reject", "return");
  };

  const handleCheckPaymentStatus = async (order) => {
    const orderId = order?.order_id ?? order?.id;
    if (!orderId) return;
    const userId = localStorage.getItem("user_id") || "";
    setCheckingPaymentOrderId(orderId);
    try {
      const url = `${API_ENDPOINTS.Refund_button_click}?user_id=${encodeURIComponent(userId)}&order_id=${encodeURIComponent(orderId)}`;
      const response = await apiService.get(url);
      const message = response?.message ?? response?.msg ?? "";
      if (response?.success) {
        await fetchProducts(statusFilter);
        toast.showSuccess(message || "Payment status checked successfully.");
      } else {
        toast.showError(message || "Check payment status failed.");
      }
    } catch (error) {
      console.error("Check payment status error:", error);
      const errMsg = error?.response?.data?.message ?? error?.message ?? "Check payment status failed.";
      toast.showError(errMsg);
    } finally {
      setCheckingPaymentOrderId(null);
    }
  };

  const handleDownloadZip = async (mode) => {
    try {
      const ids = selectedProducts.length > 0 ? selectedProducts : products.map((p) => p.id);
      const query = new URLSearchParams({
        order_ids: ids.join(","),
        mode: mode || "both",
      }).toString();
      const filename = `orders_return_cancel_${new Date().toISOString().slice(0, 10)}.zip`;
      await apiService.downloadFile(`${API_ENDPOINTS.GET_generate_zip_file}?${query}`, filename);
    } catch (error) {
      console.error("ZIP download error:", error);
      alert(error?.message || "Failed to download ZIP.");
    }
  };

  return (
    <Box pt={2} pb={4}>
      {/* Title area - same style as App Order */}
      

      {/* Two tabs: Cancel Request, Return Request */}
      <TabContainer>
        <StyledTabs
          value={statusFilter}
          onChange={handleStatusChange}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons={isMobile ? "auto" : false}
          allowScrollButtonsMobile
        >
          {TABS.map((tab) => (
            <StyledTab
              key={tab.value}
              value={tab.value}
              label={
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <span>{tab.value === "Cancelled" ? "❌" : "↩️"}</span>
                    <span>{tab.label}</span>
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      color: (theme) => getStatusColor(theme, tab.category),
                      lineHeight: 1,
                    }}
                  >
                    {statusFilter === tab.value ? products.length : counts[tab.value] ?? 0}
                  </Typography>
                </Box>
              }
            />
          ))}
        </StyledTabs>
      </TabContainer>

      {/* Search & actions - same as App Order */}
      <FlexBetween flexWrap="wrap" mb={2}>
        <FlexBox alignItems="center" gap={3}>
          <SearchInput
            bordered={false}
            placeholder="Search by Order ID or Email"
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            sx={{ minWidth: 250, width: { xs: "100%", sm: 300, md: 400 } }}
          />
        </FlexBox>
        <FlexBox alignItems="center" gap={2}>
          {selectedProducts.length > 0 && (
            <Typography variant="body2" color="primary" fontWeight={600}>
              {selectedProducts.length} selected
            </Typography>
          )}
          {/* <Button
            variant="outlined"
            startIcon={<GetApp />}
            onClick={() => setAdvancedExportModal(true)}
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, minWidth: 140 }}
          >
            Advanced Export
          </Button> */}
          {/* <Typography variant="body2" color="text.secondary">
            Showing {products.length} {statusFilter?.toLowerCase()} orders
          </Typography> */}
        </FlexBox>
      </FlexBetween>

      {/* Table - dedicated Return/Cancel table (no ProductList) */}
      <Card sx={{ marginTop: 2 }}>
        <ReturnCancelRequestTable
          data={products}
          searchQuery={searchValue}
          isLoading={isLoading}
          selectedProducts={selectedProducts}
          onProductSelect={handleProductSelect}
          onSelectAll={handleSelectAll}
          isAllSelected={isAllSelected}
          showCancelRequestActions={statusFilter === "Cancelled"}
          onApproveCancelRequest={handleApproveCancelRequest}
          onRejectCancelRequest={handleRejectCancelRequest}
          updatingCancelRequestOrderId={updatingOrderId}
          showReturnRequestActions={statusFilter === "Returned"}
          onApproveReturnRequest={handleApproveReturnRequest}
          onRejectReturnRequest={handleRejectReturnRequest}
          updatingReturnRequestOrderId={updatingReturnOrderId}
          onCheckPaymentStatus={handleCheckPaymentStatus}
          checkingPaymentOrderId={checkingPaymentOrderId}
        />
      </Card>

      {/* Pagination for Cancel and Return lists */}
      {totalPages > 1 && (
        <Box mt={2} display="flex" justifyContent="center">
          <AppPagination
            shape="rounded"
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}

      <AdvancedExportModal
        open={advancedExportModal}
        onClose={() => setAdvancedExportModal(false)}
        onRefresh={handleRefresh}
      />

      <ConfirmationDialog
        open={confirmationDialog.open}
        onClose={() => setConfirmationDialog((prev) => ({ ...prev, open: false }))}
        onConfirm={confirmationDialog.onConfirm}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        confirmButtonText={confirmationDialog.confirmButtonText}
        confirmButtonColor={confirmationDialog.confirmButtonColor}
        isLoading={updatingOrderId !== null || updatingReturnOrderId !== null}
      />
    </Box>
  );
};

export default ReturnCancelRequest;
